import { render, staticRenderFns } from "./QScoreCardHqLoginsStaff.vue?vue&type=template&id=baa38ae6&scoped=true&"
import script from "./QScoreCardHqLoginsStaff.vue?vue&type=script&lang=js&"
export * from "./QScoreCardHqLoginsStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa38ae6",
  null
  
)

export default component.exports